import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { FormOfNumber } from '~/src/components/atoms/FormOfNumber/FormOfNumber'
import { FormOfString } from '~/src/components/atoms/FormOfString/FormOfString'
import {
  CancelButton,
  SaveButton,
  DialogContent,
  DialogTitle,
  DialogInner,
  FormControls,
} from './InputDialog.styles'

interface IInputDialogProps {
  inputError: boolean
  tempValue: string
  dialogToggleState: boolean
  dialogTitle: string
  formCategory: string
  setTempValue: (param: string) => void
  setDialogToggleState: (param: boolean) => void
  handleSetValue: () => void
  handleClickDialogCancel: () => void
}

export const InputDialog: React.VFC<IInputDialogProps> = ({
  inputError,
  tempValue,
  dialogToggleState,
  setTempValue,
  setDialogToggleState,
  handleSetValue,
  dialogTitle,
  formCategory,
  handleClickDialogCancel,
}): JSX.Element => {
  const { t } = useTranslation()
  const onClickCancelButton = () => {
    handleClickDialogCancel()
    setDialogToggleState(false)
  }

  return (
    <form>
      <Dialog open={dialogToggleState}>
        <DialogInner>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>
            <FormControls>
              {formCategory === 'number' ? (
                <FormOfNumber
                  tempValue={tempValue}
                  inputError={inputError}
                  setTempValue={setTempValue}
                />
              ) : (
                <FormOfString
                  tempValue={tempValue}
                  inputError={inputError}
                  setTempValue={setTempValue}
                />
              )}
            </FormControls>
          </DialogContent>
          <CancelButton onClick={onClickCancelButton}>{t('container_order_detail.cancel')}</CancelButton>
          <SaveButton variant="contained" onClick={handleSetValue} startIcon={<SaveIcon />}>
            {t('container_order_detail.save')}
          </SaveButton>
        </DialogInner>
      </Dialog>
    </form>
  )
}
